import { motion } from "framer-motion";

const LOGOS = [
  "Apollo Care", "Lifeline Hospitals", "Manipal Group", "Fortis Network", "Aster", "Care Hospitals",
  "Yashoda", "KIMS", "Narayana", "Max Health", "AIG", "Ruby Hall",
];

export default function LogoMarquee() {
  return (
    <section data-testid="logo-marquee" className="relative bg-ab-bg py-14 border-y border-ab-border">
      <div className="ab-container mb-6">
        <p className="ab-eyebrow text-ab-muted">Trusted across multi-specialty groups, day-care chains and tertiary hospitals</p>
      </div>
      <div className="relative overflow-hidden">
        <div className="flex gap-16 ab-marquee whitespace-nowrap">
          {[...LOGOS, ...LOGOS].map((l, i) => (
            <span key={i} className="font-serif text-3xl md:text-4xl text-ab-primary/35 tracking-tight">
              {l}
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ab-bg to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ab-bg to-transparent" />
      </div>
    </section>
  );
}
